import {useIntl} from 'react-intl'
import {MENU_LABELS} from './menuMessages'
import {SidebarMenuItem} from './SidebarMenuItem'
import {useGetUser} from '../../../../../app/tfi/store/userStore'
import {canViewBilling, hasPermission, isAdministrator} from '../../../../../app/tfi/helpers'
import {ALL_PERMISSIONS} from '../../../../../app/tfi/helpers/consts'
import {SidebarMenuItemWithSub} from './SidebarMenuItemWithSub'
import {useRealtimeStore} from '../../../../../app/tfi/store/realtimeStore'

const SidebarMenuMainLegacy = () => {
  const intl = useIntl()
  const user = useGetUser((s) => s.user)
  const status = useGetUser((s) => s.status)
  const permissions = useGetUser((user) => user?.user?.permissions)
  const userGroups = useGetUser((s) => s.user?.groups) || []
  const isAgente = userGroups.includes('Agente')
  const isSupervisor = userGroups.includes('Supervisor')
  const unreadCount = useRealtimeStore((state) => state.sidebarCounters.unreadNotificationsCount)
  const openTicketsCount = useRealtimeStore((state) => state.sidebarCounters.openTicketsCount)
  const inboxUnreadCount = useRealtimeStore((state) => state.sidebarCounters.inboxUnreadCount)
  const policyChatUnreadCount = useRealtimeStore(
    (state) => state.sidebarCounters.policyChatUnreadCount
  )
  if (!permissions || !user || status !== 'user') return null

  return (
    <>
      {(isAdministrator(permissions) || isAgente || isSupervisor) &&
        hasPermission(permissions, ALL_PERMISSIONS.VIEW_POLICY) && (
          <SidebarMenuItemWithSub to='/dashboard' title={intl.formatMessage(MENU_LABELS.dashboards)} fontIcon='bi-speedometer2' icon='element-plus'>
            <SidebarMenuItem to='/dashboard/policy' title={intl.formatMessage(MENU_LABELS.dashboardByStatus)} hasBullet />
            <SidebarMenuItem to='/dashboard/executive' title={intl.formatMessage(MENU_LABELS.dashboardByCommissions)} hasBullet />
          </SidebarMenuItemWithSub>
        )}
      <SidebarMenuItem to='/calendar' title={intl.formatMessage(MENU_LABELS.calendar)} fontIcon='bi-calendar3' />
      {hasPermission(permissions, ALL_PERMISSIONS.VIEW_LEAD) && (
        <SidebarMenuItem to='/leads' title={intl.formatMessage(MENU_LABELS.leads)} fontIcon='bi-person-vcard' />
      )}
      {hasPermission(permissions, ALL_PERMISSIONS.VIEW_TASKS) && (
        <SidebarMenuItem to='/kanban' title={intl.formatMessage(MENU_LABELS.tasks)} fontIcon='bi-kanban' />
      )}
      {hasPermission(permissions, ALL_PERMISSIONS.VIEW_CAMPAIGNS) && (
        <SidebarMenuItemWithSub to='/campaigns' title={intl.formatMessage(MENU_LABELS.campaigns)} fontIcon='bi-megaphone' icon='element-plus'>
          <SidebarMenuItem to='/campaigns' title={intl.formatMessage(MENU_LABELS.campaigns)} hasBullet />
          <SidebarMenuItem to='/templates' title={intl.formatMessage(MENU_LABELS.templates)} hasBullet />
          <SidebarMenuItem to='/recipients' title={intl.formatMessage(MENU_LABELS.recipients)} hasBullet />
          <SidebarMenuItem to='/media-manager' title={intl.formatMessage(MENU_LABELS.mediaManager)} hasBullet />
          <SidebarMenuItem to='/automations' title={intl.formatMessage(MENU_LABELS.automations)} hasBullet />
        </SidebarMenuItemWithSub>
      )}
      {hasPermission(permissions, ALL_PERMISSIONS.VIEW_USER) && (
        <SidebarMenuItem to='/users' title={intl.formatMessage(MENU_LABELS.users)} fontIcon='bi-people' />
      )}
      {canViewBilling(permissions) && (
        <SidebarMenuItem to='/billing' title={intl.formatMessage(MENU_LABELS.billing)} fontIcon='bi-cash-coin' />
      )}
      {hasPermission(permissions, ALL_PERMISSIONS.VIEW_POLICY) && (
        <SidebarMenuItem to='/policies' title={intl.formatMessage(MENU_LABELS.policies)} fontIcon='bi-shield-check' />
      )}
      {hasPermission(permissions, ALL_PERMISSIONS.VIEW_POLICY) && (
        <SidebarMenuItem to='/quotes' title={intl.formatMessage(MENU_LABELS.quotes)} fontIcon='bi-clipboard-data' />
      )}
      {hasPermission(permissions, ALL_PERMISSIONS.VIEW_CONTACT) && (
        <SidebarMenuItem to='/medicare-center' title={intl.formatMessage(MENU_LABELS.medicareCenter)} fontIcon='bi-hospital' />
      )}
      {(hasPermission(permissions, ALL_PERMISSIONS.VIEW_SIGNATURE_FORMS) ||
        hasPermission(permissions, ALL_PERMISSIONS.VIEW_PDF_ENVELOPES)) && (
        <SidebarMenuItemWithSub to='/signature-forms' title={intl.formatMessage(MENU_LABELS.digitalSignatures)} fontIcon='bi-file-earmark-check' icon='element-plus'>
          {hasPermission(permissions, ALL_PERMISSIONS.VIEW_SIGNATURE_FORMS) && (
            <SidebarMenuItem to='/signature-forms' title={intl.formatMessage(MENU_LABELS.signatureForms)} hasBullet />
          )}
          {hasPermission(permissions, ALL_PERMISSIONS.VIEW_PDF_ENVELOPES) && (
            <SidebarMenuItem to='/pdf-envelopes' title={intl.formatMessage(MENU_LABELS.pdfSigning)} hasBullet />
          )}
        </SidebarMenuItemWithSub>
      )}
      {hasPermission(permissions, ALL_PERMISSIONS.VIEW_CONTACT) && (
        <SidebarMenuItem to='/contacts' title={intl.formatMessage(MENU_LABELS.contacts)} fontIcon='bi-telephone-fill' />
      )}
      <SidebarMenuItem
        to='/tickets'
        title={intl.formatMessage(MENU_LABELS.tickets)}
        fontIcon='bi-ticket-perforated'
        badge={openTicketsCount > 0 ? openTicketsCount : undefined}
      />
      {hasPermission(permissions, ALL_PERMISSIONS.VIEW_COMMISSION) && (
        <SidebarMenuItem to='/commissions' title={intl.formatMessage(MENU_LABELS.commissions)} fontIcon='bi-piggy-bank' />
      )}
      {hasPermission(permissions, ALL_PERMISSIONS.VIEW_RESOURCE_CENTER) && (
        <SidebarMenuItem to='/resource-center' title={intl.formatMessage(MENU_LABELS.resourceCenter)} fontIcon='bi-folder2-open' />
      )}
      {hasPermission(permissions, ALL_PERMISSIONS.VIEW_ACADEMY) && (
        <SidebarMenuItem to='/academy' title={intl.formatMessage(MENU_LABELS.academy)} fontIcon='bi-mortarboard' />
      )}
      <SidebarMenuItem
        to='/notifications'
        title={intl.formatMessage(MENU_LABELS.notifications)}
        fontIcon='bi-bell'
        badge={unreadCount > 0 ? unreadCount : undefined}
      />
      {hasPermission(permissions, ALL_PERMISSIONS.VIEW_INTEGRATION) && (
        <SidebarMenuItem to='/integrations' title={intl.formatMessage(MENU_LABELS.integrations)} fontIcon='bi-diagram-3' />
      )}
      {hasPermission(permissions, ALL_PERMISSIONS.VIEW_COMMUNICATION_LOGS) && (
        <SidebarMenuItem
          to='/inbox'
          title={intl.formatMessage(MENU_LABELS.inbox)}
          fontIcon='bi-chat-square-text'
          badge={inboxUnreadCount > 0 ? inboxUnreadCount : undefined}
        />
      )}
      <SidebarMenuItem
        to='/policychat'
        title={intl.formatMessage(MENU_LABELS.policyChat)}
        fontIcon='bi-chat-heart'
        badge={policyChatUnreadCount > 0 ? policyChatUnreadCount : undefined}
      />
    </>
  )
}

export {SidebarMenuMainLegacy}
